import React, { useMemo } from 'react';

import { EXAMINATION, usePermissions } from 'permissions';
import { useExaminationTasks, useExaminations } from 'store/examinations';
import Spinner from 'components/FullScreenSpinner';
import QuestionContainer from 'components/QuestionContainer';

import { extractData } from './utils';
import { Message, Select } from './styles';
import Item from './Item';

const ExaminationsTasks = () => {
  const can = usePermissions();
  const { loading, success, error, filter, setFilter, filterOptions } = useExaminationTasks(can.read(EXAMINATION));
  const examinations = useExaminations();
  const values = useMemo(() => extractData(examinations), [examinations]);

  if (loading || !(success || error)) return <Spinner />;

  if (error) return <Message type="error">{error}</Message>;

  return (
    <QuestionContainer label="Patienten im Untersuch">
      <Select value={filter} options={filterOptions} onSelect={setFilter} />
      {!values.length && (
        <Message type="error">Sobald bei einem Untersuch eine Aufgabe erledigt wird, erscheint der Patient hier.</Message>
      )}
      {values.map((item) => (
        <Item key={item.id} {...item} />
      ))}
    </QuestionContainer>
  );
};

export default ExaminationsTasks;
